import { Parser } from "./Parser";
var LogParser = /** @class */ (function () {
    function LogParser() {
        this._parser = new Parser();
    }
    LogParser.prototype.parse = function (content, startIndex, linesLength) {
        return this._parser.parseLines(content, startIndex, linesLength);
    };
    return LogParser;
}());
export { LogParser };
